export const supportTicketStatuses = [
    "Open",
    "In Progress",
    "Waiting on Requester",
    "Resolved",
    "Closed",
];
export const supportTicketPriorities = ["Low", "Normal", "High", "Urgent"];
export const memberSupportTicketCategories = [
    "Account / Login",
    "Mobile App Issue",
    "Prayer / Iqamah",
    "Events / Announcements",
    "Ramadan / Iftar",
    "Profile",
    "Notification Issue",
    "General Question",
    "Other",
];
export const shdeedSupportTicketCategories = [
    "Technical Issue",
    "User / Access Issue",
    "Mobile App",
    "Org Admin Portal",
    "Configuration",
    "Data / Migration",
    "Security / Privacy",
    "Feature Request",
    "Billing / Subscription",
    "Other",
];
export const supportAttachmentMimeTypes = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/heic",
    "image/heif",
];
export const supportAttachmentExtensions = ["jpg", "jpeg", "png", "webp", "heic", "heif"];
export const maxSupportAttachmentsPerMessage = 5;
export const maxSupportAttachmentBytes = 10 * 1024 * 1024;
export const maxSupportSubjectLength = 140;
export const maxSupportDescriptionLength = 2_000;
export const minSupportSubjectLength = 3;
export const minSupportDescriptionLength = 10;
export function isSupportTicketStatus(value) {
    return typeof value === "string" && supportTicketStatuses.includes(value);
}
export function isSupportTicketPriority(value) {
    return (typeof value === "string" && supportTicketPriorities.includes(value));
}
export function isMemberSupportTicketCategory(value) {
    return (typeof value === "string" &&
        memberSupportTicketCategories.includes(value));
}
export function isShdeedSupportTicketCategory(value) {
    return (typeof value === "string" &&
        shdeedSupportTicketCategories.includes(value));
}
export function isSupportAttachmentMimeType(value) {
    return (typeof value === "string" &&
        supportAttachmentMimeTypes.includes(value));
}
export function isSupportAttachmentExtension(value) {
    return (typeof value === "string" &&
        supportAttachmentExtensions.includes(value.toLowerCase()));
}
export function normalizeSupportSubject(value) {
    return normalizeSupportText(value, {
        maxLength: maxSupportSubjectLength,
        minLength: minSupportSubjectLength,
    });
}
export function normalizeSupportDescription(value) {
    return normalizeSupportText(value, {
        maxLength: maxSupportDescriptionLength,
        minLength: minSupportDescriptionLength,
    });
}
export function isSafeSupportTicketId(value) {
    return (typeof value === "string" &&
        /^[A-Za-z0-9][A-Za-z0-9_-]{1,119}$/u.test(value) &&
        !value.includes("/"));
}
export function isSafeSupportAttachmentFileName(value) {
    if (typeof value !== "string") {
        return false;
    }
    const match = value.match(/^support-[0-9]{10,17}-[a-z0-9_-]{1,48}\.([A-Za-z0-9]+)$/u);
    return Boolean(match?.[1] && isSupportAttachmentExtension(match[1]));
}
export function buildMemberSupportTicketRoute(input) {
    return `shdeed://support/member/${encodeURIComponent(input.organizationId)}/${encodeURIComponent(input.ticketId)}`;
}
function normalizeSupportText(value, limits) {
    if (typeof value !== "string") {
        return { accepted: false, reason: "empty" };
    }
    const normalized = value.trim().replace(/\s+/gu, " ");
    if (normalized.length === 0) {
        return { accepted: false, reason: "empty" };
    }
    if (normalized.length < limits.minLength) {
        return { accepted: false, reason: "too_short" };
    }
    if (normalized.length > limits.maxLength) {
        return { accepted: false, reason: "too_long" };
    }
    return {
        accepted: true,
        value: normalized,
    };
}
